export type TimeFormat = 'utc' | 'local' | 'relative';

export function getStoredTimeFormat(): TimeFormat {
  return (localStorage.getItem('eventstore-time-format') as TimeFormat) || 'relative';
}

export function setStoredTimeFormat(format: TimeFormat): void {
  localStorage.setItem('eventstore-time-format', format);
}

export function formatTimestamp(ts: string | undefined, format: TimeFormat): string {
  if (!ts) return '—';
  try {
    const date = new Date(ts);
    if (isNaN(date.getTime())) return ts;
    switch (format) {
      case 'utc':
        return date.toISOString().replace('T', ' ').substring(0, 19) + ' UTC';
      case 'local':
        return date.toLocaleString();
      case 'relative': {
        const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
        if (seconds < 0) return 'just now';
        if (seconds < 60) return `${seconds}s ago`;
        if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
        if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
        return `${Math.floor(seconds / 86400)}d ago`;
      }
    }
  } catch {
    return ts;
  }
}
